// Centralized API configuration
export const API_BASE_URL = '/api/v1';
export const API_V2_BASE_URL = '/api/v2';

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// Helper function to build full v2 API URLs
export const buildApiV2Url = (endpoint: string): string => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_V2_BASE_URL}/${cleanEndpoint}`;
};
